import {IconButton, InputAdornment, TextField} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useCallback} from 'react';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  placeholder
}) => {
  const handleClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  return (
    <TextField
      variant="outlined"
      margin="normal"
      fullWidth
      label={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} edge="end">
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  );
};

export default SearchField;
